import * as actionTypes from "../consts/actionTypes";

export function getPlanPdfByPlanCodeAction(planCode) {
    return {
        type: actionTypes.GET_PLANPDF_BY_PLANCODE,
        payload: planCode
    };
}